import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import { QueryKeyLocalStorageEnum, SchedulesHistoryQueryKeysEnum } from 'context/query/queryContext/QueryContext.enum';
import { fetchServers } from 'api/servers/servers';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { fetchSchedulesHistory } from 'api/schedules/schedules';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';

import { useSchedulesHistorySearchQuery } from './hooks/useSchedulesHistorySearchQuery';
import { SchedulesHistory } from './SchedulesHistory';

export const SchedulesHistoryContainer = () => {
  const {
    storedQueries: { schedulesHistory: schedulesHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();
  const {
    tkdSearchQuery,
    executorSearchQuery,
    scheduleSearchQuery,
    setExecutorSearchQuery,
    setScheduleSearchQuery,
    setTkdSearchQuery,
    clearSearchQueries,
  } = useSchedulesHistorySearchQuery();

  const { page, rowsPerPage, setPage, setRowsPerPage, storedQueryWithoutPagination, setPaginationCount } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.SCHEDULES_HISTORY,
      resetPaginationDependencyArray: [tkdSearchQuery, executorSearchQuery],
    });

  const { data: serversResponse } = useQuery([QueryKeyEnum.SERVERS], fetchServers);

  const { data: schedulesHistoryResponse, isLoading } = useQuery(
    [
      QueryKeyEnum.SCHEDULES_HISTORY,
      storedQueryWithoutPagination,
      rowsPerPage,
      page,
      tkdSearchQuery,
      executorSearchQuery,
      scheduleSearchQuery,
    ],
    () => fetchSchedulesHistory(),
    {
      args: {
        ...storedQueryWithoutPagination,
        [SchedulesHistoryQueryKeysEnum.SERWER]: schedulesHistoryQuery.serwer?.value,
        [SchedulesHistoryQueryKeysEnum.CZYTNIK]: schedulesHistoryQuery.tkd?.value,
        [SchedulesHistoryQueryKeysEnum.QUERY]: schedulesHistoryQuery.query?.value,
        [SchedulesHistoryQueryKeysEnum.NAZWA]: schedulesHistoryQuery.nazwa?.value,
        [SchedulesHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [SchedulesHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearControlHistoryQuery = () => {
    setQuery(QueryKeyLocalStorageEnum.SCHEDULES_HISTORY, {
      page,
      rowsPerPage,
    });
    clearSearchQueries();
  };

  return (
    <SchedulesHistory
      schedulesHistoryResponse={schedulesHistoryResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      servers={serversResponse?.data || []}
      tkdSearchQuery={tkdSearchQuery}
      executorSearchQuery={executorSearchQuery}
      scheduleSearchQuery={scheduleSearchQuery}
      setExecutorSearchQuery={setExecutorSearchQuery}
      setScheduleSearchQuery={setScheduleSearchQuery}
      setTkdSearchQuery={setTkdSearchQuery}
      onClearControlHistoryQuery={onClearControlHistoryQuery}
    />
  );
};
